import { Accordion } from '@fattureincloud/fic-design-system'
import React, { FC } from 'react'

import { useAppSelector } from '../../redux/hooks'
import { SectionContainer, SectionList } from '../common.components'
import { SectionInfo } from '../definitions'

export interface SubsectionProps {
  isExternal: boolean
  type: 'section' | 'subsection' | 'subsubsection'
  idx: number
  embedded: boolean
  subSection: SectionInfo
  changeView: (permalink: string, type: string) => void
}

const Subsection: FC<SubsectionProps> = (props: SubsectionProps) => {
  const editorModeActive = useAppSelector((state) => state.editor.value)

  const title = (
    <>
      {editorModeActive && <>{props.subSection.id} - </>}
      {props.subSection.title}
    </>
  )

  const getRenderTitle = () => {
    let rendererTitle = <h2>{title}</h2>
    if (props.type === 'subsection') rendererTitle = <h3>{title}</h3>
    if (props.type === 'subsubsection') rendererTitle = <h4>{title}</h4>
    return rendererTitle
  }

  return (
    <SectionContainer
      isExternal={props.isExternal}
      key={props.idx}
      className={`sectionContainer ${props.embedded ? 'embeddedSection' : ''}`}
    >
      <SectionList>
        <Accordion
          renderTitle={getRenderTitle}
          renderBody={() => (
            <>
              {props.subSection.articles && (
                <ul>
                  {props.subSection.articles.map((article, idx) => {
                    return (
                      <li
                        key={idx}
                        onClick={() =>
                          props.changeView(article.permalink, 'articolo')
                        }
                      >
                        <span>
                          {editorModeActive && <>{article.id} - </>}
                          {article.title}
                        </span>
                      </li>
                    )
                  })}
                </ul>
              )}
              {props.subSection.subSections &&
                props.subSection.subSections.length > 0 &&
                props.subSection.subSections.map((subSubSection, subIdx) => {
                  return (
                    <Subsection
                      type={'subsection'}
                      isExternal={props.isExternal}
                      idx={subIdx}
                      embedded={props.embedded}
                      subSection={subSubSection}
                      changeView={props.changeView}
                    />
                  )
                })}
              {props.subSection.subSubSections &&
                props.subSection.subSubSections.length > 0 &&
                props.subSection.subSubSections.map((subSubSection, subIdx) => {
                  return (
                    <Subsection
                      type={'subsubsection'}
                      isExternal={props.isExternal}
                      idx={subIdx}
                      embedded={props.embedded}
                      subSection={subSubSection}
                      changeView={props.changeView}
                    />
                  )
                })}
            </>
          )}
        />
      </SectionList>
    </SectionContainer>
  )
}

export default Subsection
